<template>
    <header id="header-container" class="fullwidth hidden-lg hidden-xl" :class="$router.currentRoute.meta.topClass ? $router.currentRoute.meta.topClass : null">

        <!-- Header -->
        <div id="header">
            <div class="container" style="width: 100%;">
                
                <!-- Left Side Content -->
                <div class="left-side">
                    
                    <div class="left-button hidden-xl" v-if="$router.currentRoute.meta.backButton">
                        <a v-on:click="$root.back()">
                            <i class="las la-arrow-left"></i>
                        </a>
                    </div>

                    <span class="mmenu-trigger" v-if="!$router.currentRoute.meta.backButton">
                        <button class="hamburger hamburger--collapse" type="button">
                            <i class="las la-bars"></i>
                        </button>
                    </span>

                    <div id="logo" v-show="!($router.currentRoute.meta.hideTitle ? $router.currentRoute.meta.hideTitle : false)">
                        <a>
                            {{title ? title : $router.currentRoute.meta.title}}
                            <i v-if="tooltip" class="las la-info-circle tooltip-top-toggle" v-on:click="tooltipShow = !tooltipShow">
                                <div
                                    class="tooltip-top" 
                                    data-tippy-pos="bottom"
                                    :data-tippy-visible="tooltipShow"
                                    :data-tippy="tooltip ? tooltip : ''">
                                </div>
                            </i>
                        </a>
                    </div>

                </div>


                <div class="right-side top-right-compact">
                    <ContadorSessao v-show="$root.logged && $root.user"/>
                    <button v-show="$root.logged && $root.user && $root.user.tipos && $root.user.tipos.length > 1"
                            class="trocar-tipo-top trocar-tipo-avatar" type="button"
                            v-on:click="$root.abrirSelecaoTipo()"
                            :title="'Trocar perfil (' + $root.labelTipo($root.user.tipo) + ')'">
                        <img :src="$root.user.imagem" class="avatar-mobile-mini">
                        <i class="las la-angle-down trocar-tipo-top-arrow"></i>
                    </button>
                    <router-link v-show="$root.logged && $root.user" to="/minha-conta#notificacoes" class="notif-mobile">
                        <i class="las la-bell"></i>
                        <span v-if="$root.notificacoes && $root.notificacoes.news > 0" class="notif-badge-mobile">{{$root.notificacoes.news > 99 ? "+99" : "+" + $root.notificacoes.news}}</span>
                    </router-link>
                </div>
                <!-- Right Side Content / End -->

            </div>
        </div>
        <!-- Header / End -->

    </header>
    <!-- <div class="clearfix"></div>     -->
</template>

<script>
import ContadorSessao from './ContadorSessao'

export default {
    name: 'Top',
    props: ['tooltip','title'],
    components: {
        'ContadorSessao': ContadorSessao
    },
    data () {
        return {
            tooltipShow: false
        }
    },
    methods: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mmenu-trigger i {
        font-size: 38px;
        color: #fff;
    }
    .trocar-tipo-top {
        background: rgba(255,255,255,0.15);
        border: 1px solid rgba(255,255,255,0.3);
        color: #fff;
        padding: 6px 10px;
        border-radius: 8px;
        margin-right: 10px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        transition: background .15s ease;
    }
    .trocar-tipo-top:hover,
    .trocar-tipo-top:active {
        background: rgba(255,255,255,0.25);
    }
    .trocar-tipo-top i {
        font-size: 20px;
    }
    .trocar-tipo-top-arrow {
        font-size: 14px !important;
        opacity: 0.7;
    }
    .trocar-tipo-icon {
        padding: 6px 8px;
        margin-right: 0;
    }
    .trocar-tipo-avatar {
        padding: 3px 6px 3px 3px;
        margin-right: 0;
    }
    .avatar-mobile-mini {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        object-fit: cover;
        border: 1.5px solid rgba(255,255,255,0.5);
    }
    .top-right-compact {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
        padding-right: 6px;
        position: relative; /* ancora o ContadorSessao absoluto em mobile */
    }
    /* Evita o título "#logo" do left-side invadir o right-side em telas estreitas */
    #header .left-side {
        min-width: 0;
        overflow: hidden;
    }
    #header #logo {
        min-width: 0;
        max-width: 100%;
    }
    #header #logo a {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .notif-mobile {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        color: #fff;
    }
    .notif-mobile i {
        font-size: 22px;
    }
    .notif-badge-mobile {
        position: absolute;
        top: 0;
        right: 0;
        background: #E53935;
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        padding: 1px 4px;
        border-radius: 999px;
        line-height: 1.4;
        min-width: 16px;
        text-align: center;
        box-sizing: border-box;
    }
    .top-right-compact {
        padding-right: 6px;
    }
    #header-container, #header { background: var(--theme-color-primary) !important; }
    #header .left-side, #header .container { background: inherit; }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue